import { getApiUrl, defaultHeaders } from "./config";

export const userService = {
   // Get User by ID
   getById: async (id) => {
      const response = await fetch(getApiUrl(`/api/user/${id}`));
      if (!response.ok) throw new Error("User not found");
      return response.json();
   },

   // Get User by Email
   getByEmail: async (email) => {
      const response = await fetch(getApiUrl(`/api/user/email/${email}`));
      if (!response.ok) throw new Error("User not found");
      return response.json();
   },

   // Create New User
   create: async (userData) => {
      const response = await fetch(getApiUrl("/api/user"), {
         method: "POST",
         headers: defaultHeaders,
         body: JSON.stringify(userData),
      });
      if (!response.ok) throw new Error("Failed to create user");
      return response.json();
   },

   // Update User
   update: async (email, userData) => {
      const response = await fetch(getApiUrl(`/api/user/email/${email}`), {
         method: "PUT",
         headers: defaultHeaders,
         body: JSON.stringify(userData),
      });
      if (!response.ok) throw new Error("Failed to update user");
      return response.json();
   },
};
